/*!

=========================================================
* Material Dashboard React - v1.7.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/material-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
import PropTypes from "prop-types";
import { Switch, Route, Redirect } from "react-router-dom";

import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";

import withStyles from "@material-ui/core/styles/withStyles";

import Navbar from "components/Navbars/Navbar.jsx";

import Sidebar from "components/Sidebar/Sidebar.jsx";

import routes from "admin-routes.js";
import { projectAssets } from "base-routes.js";

import dashboardStyle from "assets/jss/material-dashboard-react/layouts/dashboardStyle.jsx";

import { DEFAULT_PROFILE_IMG, NO_USERNAME } from "__helpers/constants";
import "react-notifications-component/dist/theme.css";
import ReactNotification from "react-notifications-component";
import { SELECTED_ADNETWORK } from "__helpers/constants";
import { userService } from "_services/user.service";
import moment from "moment";
import GlobalApis from "components/Sidebar/GlobalApis";
import { USER_INFO } from "__helpers/constants";

class Dashboard extends React.Component {
  constructor(props) {
    super(props);
    this.updateUserInfo = this.updateUserInfo.bind(this);
    this.sendAdnetworkData = this.sendAdnetworkData.bind(this);
    this.saveDataToLocalStorage = this.saveDataToLocalStorage.bind(this);

    let userDetail = JSON.parse(localStorage.getItem(USER_INFO));
    let selectedAdnetwork = JSON.parse(localStorage.getItem(SELECTED_ADNETWORK));
    let profileImage = DEFAULT_PROFILE_IMG;
    if (userDetail && userDetail.imageRef) {
      profileImage = userDetail.imageRef;
    }
    let tokenTimeStamp = localStorage.getItem("tokenTimeStamp");
    var dateTimeVal = new Date(+tokenTimeStamp);
    var validDateBoolean = moment(dateTimeVal);
    if (!validDateBoolean.isValid()) {
      // userService.logout();
    }
    let username =
      userDetail && userDetail.firstName
        ? `${userDetail.firstName} ${userDetail.lastName}`
        : NO_USERNAME;

    this.state = {
      userDetail: {
        profileImage: profileImage,
        username: username
      },
      selectedAdnetwork: (selectedAdnetwork) ? selectedAdnetwork : [],
      localStorageData: {},
      hasError: "",
      error: "",
      errorInfo: "",
      time: {},
      seconds: 1500,
      tokenTimeStamp: tokenTimeStamp,
    };

    this.timer = 0;
    this.startTimer = this.startTimer.bind(this);
    this.countDown = this.countDown.bind(this);
  }
  state = {
    image: projectAssets.blur_image,
    color: "blue",
    hasImage: true,
    fixedClasses: "dropdown show",
    mobileOpen: false,
    loggedIn: false
  };

  adminRoutes = {};
  secondsToTime(secs) {
    let hours = Math.floor(secs / (60 * 60));

    let divisor_for_minutes = secs % (60 * 60);
    let minutes = Math.floor(divisor_for_minutes / 60);

    let divisor_for_seconds = divisor_for_minutes % 60;
    let seconds = Math.ceil(divisor_for_seconds);

    let obj = {
      "h": hours,
      "m": minutes,
      "s": seconds
    };
    return obj;
  }
  saveDataToLocalStorage = storageName => {
  };
  updateUserInfo = userDetail => {
    let username = NO_USERNAME;
    let profileImage = DEFAULT_PROFILE_IMG;
    if (!userDetail) {
      const userDetail = JSON.parse(localStorage.getItem(USER_INFO));
      username =
        userDetail && userDetail.firstName
          ? `${userDetail.firstName} ${userDetail.lastName}`
          : NO_USERNAME;
      if (userDetail.imageRef) {
        profileImage = userDetail.imageRef;
      }
    } else {
      if (userDetail && userDetail.profileImage) {
        profileImage = userDetail.profileImage;
      }

      username =
        userDetail && userDetail.firstName
          ? `${userDetail.firstName} ${userDetail.lastName}`
          : NO_USERNAME;
    }
    this.setState({
      userDetail: {
        profileImage: profileImage,
        username: username
      }
    });
  };
  sendAdnetworkData = selectedAdnetwork => {
  }

  mainPanel = React.createRef();
  handleImageClick = image => {
    this._isMounted && this.setState({ image: image });
  };
  handleColorClick = color => {
    this.setState({ color: color });
  };
  handleFixedClick = () => {
    if (this.state.fixedClasses === "dropdown") {
      this._isMounted && this.setState({ fixedClasses: "dropdown show" });
    } else {
      this._isMounted && this.setState({ fixedClasses: "dropdown" });
    }
  };
  handleDrawerToggle = () => {
    this.setState({ mobileOpen: !this.state.mobileOpen });
  };
  getRoute() {
    return window.location.pathname !== "/admin/maps";
  }
  resizeFunction = () => {
    if (window.innerWidth >= 960) {
      this.setState({ mobileOpen: false });
    }
  };
  startTimer() {
    if (this.timer == 0 && this.state.seconds > 0) {
      this.timer = setInterval(this.countDown, 1000);
    }
  }
  countDown() {
    let seconds = this.state.seconds - 1;
    this.setState({
      time: this.secondsToTime(seconds),
      seconds: seconds,
    });
    let currentTimeStamp = new Date().getTime();
    if ((currentTimeStamp - this.state.tokenTimeStamp) > 1700000) {
      // userService.logout();
      clearInterval(this.timer);
    }
    if (seconds == 0) {
      clearInterval(this.timer);
    }
  }
  componentDidMount() {
    window.addEventListener("resize", this.resizeFunction);
    let timeLeftVar = this.secondsToTime(this.state.seconds);
    this.setState({ time: timeLeftVar });
    this.startTimer();
  }

  componentDidCatch(error, errorInfo) {
    this._isMounted && this.setState({
      hasError: true,
      error: error,
      errorInfo: errorInfo
    });
  }

  componentDidUpdate(e) {
    if (e.history.location.pathname !== e.location.pathname) {
      if (this.mainPanel && this.mainPanel.current) {
        this.mainPanel.current.scrollTop = 0;
      }
      if (this.state.mobileOpen) {
        this._isMounted && this.setState({ mobileOpen: false });
      }
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
    window.removeEventListener("resize", this.resizeFunction);
    Object.getPrototypeOf(this).constructor.STATE = this.state;
  }
  render() {
    const { classes, match, ...rest } = this.props;
    const {
      mobileOpen,
      color,
      userDetail,
      hasError,
      localStorageData,
      selectedAdnetwork
    } = this.state;
    return (
      <div
        className={classes.wrapper + " admin-panel-cover"}
        style={{ backgroundColor: "rgb(239, 235, 235)" }}
      >
        <div className="display-none storage-observation">no change</div>
        <GlobalApis/>
        <Sidebar
          role="admin"
          routes={routes}
          logoText={projectAssets.brandShortName}
          logo={projectAssets.logo}
          style={{ backgroundColor: "#2d4e80" }}
          image={projectAssets.blur_image}
          handleDrawerToggle={this.handleDrawerToggle}
          open={mobileOpen}
          color={color}
          updateUserInfo={this.updateUserInfo}
          saveDataToLocalStorage={this.saveDataToLocalStorage}
          localStorageData={localStorageData}
          userDetail={userDetail}
          selectedAdnetwork={selectedAdnetwork}
          sendAdnetworkData={this.sendAdnetworkData}
          {...rest}
        />
        <div className={classes.mainPanel} ref={this.mainPanel}>
		      <Navbar
            logoText={projectAssets.brandShortName}
            logo={projectAssets.logo}
            role="admin"
            routes={routes}
            handleDrawerToggle={this.handleDrawerToggle}
            updateUserInfo={this.updateUserInfo}
            userDetail={userDetail}
            sendAdnetworkData={this.sendAdnetworkData}
            {...rest}
          />
          {this.getRoute() && !hasError ? (
            <div className={classes.content}>
              <div className={classes.container}>
                {" "}
                {
                  <Switch>
                    {routes.map((prop, key) => {
                      return (
                        <Route
                          path={prop.basePath + prop.path}
                          key={key}
                          render={props => (
                            <prop.component
                              {...props}
                              updateUserInfo={this.updateUserInfo}
                              key={this.props.location.key}
                            />
                          )}
                        ></Route>
                      );
                    })}
                    {<Redirect from="/admin" to="/admin/dashboard" />}
                  </Switch>
                }
              </div>
            </div>
          ) : (
              "Error During"
            )}
        </div>
      </div>
    );
  }
}

Dashboard.propTypes = {
  classes: PropTypes.object.isRequired,
  userDetail: PropTypes.object
};

export default withStyles(dashboardStyle)(Dashboard);
